export const ItemTypes = {
	SAMPLE: 'SAMPLE',
	DUMMY: 'DUMMY',
};

export const ItemTypeDelimiter = '#';
